import React from "react";
import { setLanguage } from "../_helpers/language";
import { LangSwitch } from "./LangSwitch";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

import "../css/style.css";
import { connect } from "react-redux";
import i18next from "i18next";
import { history, store } from "../_helpers";
import { userService } from "../_services/user.service";
import { appActions, userActions } from "../_actions";
import personLogo from "../img/person.png";
import { MenuIcon as SideMenuIcon } from "./MenuIcon";
import { Logo } from "./Logo";
import { faTicketAlt, faUsers, faCog } from "@fortawesome/free-solid-svg-icons";
import logoMark from "../img/logo-mark.svg";

const ACTIVE_COLOR = "#0c2441";
const MENU_ICON_SIZE = 22;

// Тёмный фон раньше стоял только на самих пунктах, а подложка меню оставалась
// белой: пункты шире неё (кегль 30 и иконки 40 не помещались в телефон)
// вылезали за край, и по краю шла белая «лесенка». Красим Paper, а пункты
// оставляем прозрачными и разрешаем переносить длинную подпись
// («Участники мероприятий») на вторую строку.
const MENU_PAPER_SX = {
  backgroundColor: ACTIVE_COLOR,
  color: "#fff",
  minWidth: 220,
  maxWidth: "calc(100vw - 32px)",
};

const MENU_ITEM_SX = {
  px: 2.5,
  py: 1.5,
  fontSize: 17,
  color: "#fff",
  whiteSpace: "normal",
};

function getCookie(name) {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
  options = options || {};
  let { expires } = options;
  if (typeof expires === "number" && expires) {
    const d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }

  if (expires && expires.toUTCString) options.expires = expires.toUTCString();

  value = encodeURIComponent(value);
  let updatedCookie = `${name}=${value}`;
  for (const propName in options) {
    updatedCookie += `; ${propName}`;
    const propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  }

  document.cookie = updatedCookie;
}

function setStorage(name, val) {
  localStorage.setItem(name, val);
}

class HeadMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { anchorEl: null };
  }

  componentDidMount() {
    this.setState({ isMobile: window.screen.width < 600 });
  }

  changeLang = (lang) => {
    const { dispatch } = this.props;

    // Локаль профиля главнее локали устройства: MainPage применяет
    // user.info.locale на каждое обновление стора. Поэтому профиль правим
    // первым — иначе подписка увидит расхождение и вернёт прежний язык
    // раньше, чем ответит сервер (выбор в шапке просто не срабатывал).
    const info = store.getState().user.info;
    if (info) {
      dispatch(userActions.setuser({ ...info, locale: lang }));
      // Тем же полем язык меняет селект в настройках; бэкенд помнит его
      // между устройствами. Ошибку показывает сам сервис.
      userService.patchWrapperBody(
        "api/user",
        { profile_locale: lang },
        (data) => {
          const updated = (data && data.data) || { ...info, locale: lang };
          localStorage.setItem("user", JSON.stringify(updated));
        },
        () => {}
      );
    }

    // setLanguage делает всё разом: запоминает выбор, переинициализирует i18next
    // и вешает на body класс lang-*, от которого зависят размеры шрифта для
    // иероглифов (cjk.css). Раньше класс здесь не обновлялся.
    if (!setLanguage(lang)) return;
    dispatch(appActions.setlang(lang));
  };

  onLogout = () => {
    setStorage("navic_user", "");
    setStorage("token", "");
    localStorage.setItem("conf", '{"id":0}');
    localStorage.setItem("user", null);

    history.push("/login");
  };

  handleClose = (name) => {
    let contacts = "support@naviconf.com";

    this.setState({ anchorEl: null });
    if (name == "confs" || name == "tickets" || name == "partips" || name == "settings") this.props.menuPress(name);

    //window.location.href = 'https://naviconf.com/poll-qf07q4yhf1q40879hfq12.htm';
    //window.open('https://naviconf.com/poll-qf07q4yhf1q40879hfq12.htm');

    

    if (name == "mail") window.open(`mailto:${contacts}`);

    if (name == "exit") this.onLogout();
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  render() {
    const self = this;
    const { lang } = this.props.app;
    const { anchorEl, isMobile } = this.state;

    return (
      <div style={{ flexShrink: 0 }}>
        <ul
          className="header__blocks"
          style={{ border: "1px solid " + ACTIVE_COLOR }}
        >
          <li className="header__block header__form">
            {this.props.type != "student" && this.props.onMenuToggle && (
              <div className="mobile-menu-btn" onClick={this.props.onMenuToggle}>
                <IconButton size="large" color="inherit">
                  <MenuIcon />
                </IconButton>
              </div>
            )}
            {this.props.type == "student" && (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  <MenuIcon size="large" />
                  <span style={{ paddingLeft: 10, fontSize: 20 }}>
                    {i18next.t("menu")}
                  </span>
                </IconButton>

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                  PaperProps={{ sx: MENU_PAPER_SX }}
                  MenuListProps={{ sx: { py: 0 } }}
                >
                  <MenuItem
                    onClick={() => this.handleClose("")}
                    sx={MENU_ITEM_SX}
                  >
                    <Logo />
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.handleClose("confs")}
                    sx={MENU_ITEM_SX}
                  >
                    <SideMenuIcon
                      img={logoMark}
                      size={MENU_ICON_SIZE}
                      style={{ marginRight: 12, flexShrink: 0 }}
                    />
                    <span>{i18next.t("confs_title")}</span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.handleClose("tickets")}
                    sx={MENU_ITEM_SX}
                  >
                    <SideMenuIcon
                      img={faTicketAlt}
                      size={MENU_ICON_SIZE}
                      style={{ marginRight: 12, flexShrink: 0 }}
                    />
                    <span>{i18next.t("tickets")}</span>
                  </MenuItem>

                  <MenuItem
                    onClick={() => this.handleClose("partips")}
                    sx={MENU_ITEM_SX}
                  >
                    <SideMenuIcon
                      img={faUsers}
                      size={MENU_ICON_SIZE}
                      style={{ marginRight: 12, flexShrink: 0 }}
                    />
                    <span>{i18next.t("partips")}</span>
                  </MenuItem>

                  <MenuItem
                    onClick={() => this.handleClose("settings")}
                    sx={MENU_ITEM_SX}
                  >
                    <SideMenuIcon
                      img={faCog}
                      size={MENU_ICON_SIZE}
                      style={{ marginRight: 12, flexShrink: 0 }}
                    />
                    <span>{i18next.t("settings")}</span>
                  </MenuItem>

                  <MenuItem
                    onClick={() => this.handleClose("mail")}
                    sx={MENU_ITEM_SX}
                  >
                    <span>{i18next.t("support")}</span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.handleClose("exit")}
                    sx={MENU_ITEM_SX}
                  >
                    <span>{i18next.t("exit")}</span>
                  </MenuItem>
                </Menu>
              </div>
            )}
          </li>

          <li className="header__block">
            <a href="#" className="profile">
              <img src={personLogo} alt="" className="profile__img" />
              <span className="profile__name">
                {self.props.name ? self.props.name : self.props.email}
              </span>
            </a>
          </li>

          {!isMobile && (
            <li className="header__block">
              <div className="block-dropdown">
                <button className="block-dropdwon__btn">
                  {self.props.type == "org" && (
                    <span>{i18next.t("type_org")}</span>
                  )}
                  {self.props.type == "student" && (
                    <span>{i18next.t("type_visitor")}</span>
                  )}
                  {self.props.type == "team_member" && (
                    <span>{i18next.t("type_member")}</span>
                  )}
                  {self.props.type == "superuser" && (
                    <span>{i18next.t("superuser")}</span>
                  )}
                  <svg
                    className="block-dropdwon__icon"
                    width="10"
                    height="7"
                    fill="none"
                  >
                    <use href="./img/sprite.svg#dropdown-icon" />
                  </svg>
                </button>
              </div>
            </li>
          )}

          {/* На телефоне переключатель раньше жил внутри выезжающего меню, под
              логотипом, и читался как часть шапки меню, а не как отдельная
              настройка (пункт 41 QA-таблицы). Теперь он там же, где на широком
              экране, — в строке с профилем и кнопкой выхода. */}
          <li className="header__block">
            <LangSwitch lang={lang} onChange={self.changeLang} />
          </li>

          {(!isMobile || self.props.type != "student") && (
            <li className="header__block">
              <div className="lang">
                <button className="block-dropdwon__btn" onClick={self.onLogout}>
                  <span>{i18next.t("exit")}</span>
                </button>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;
  // const {user} = authentication;
  const { unresolvedAppealCount } = app;
  return {
    user,
    app,
    authentication,
  };
}

const connectedHeadMenu = connect(mapStateToProps)(HeadMenu);
export { connectedHeadMenu as HeadMenu };
